/* eslint-disable no-use-before-define */
import axios from 'axios';
import config from 'services/config';

const { apiServer } = config;

const loginUrl = `${apiServer}/v1/iam/login`;
const ssoLoginUrl = `${apiServer}/v1/iam/api-login`;
const createUserUrl = `${apiServer}/v1/iam/activate-new-user`;
// Public APIs - no authentication required
const forgotPasswordUrl = '/api/ccp/v1/user/forgotpassword';
const resetPasswordUrl = '/api/ccp/v1/user/resetpassword';

export default {
  login,
  ssoLogin,
  createUser,
  forgotPassword,
  resetPassword
};

function login(username, password) {
  return axios.post(loginUrl, { username, password });
}

function ssoLogin(ssoToken) {
  return axios.post(ssoLoginUrl, { ssoToken });
}

function createUser(username, password) {
  return axios.post(createUserUrl, { Login: username, Password: password });
}

function forgotPassword(email) {
  return axios.post(forgotPasswordUrl, { Email: email });
}

function resetPassword(token, newPassword, confirmPassword) {
  return axios.post(resetPasswordUrl, { Token: token, NewPassword: newPassword, ConfirmPassword: confirmPassword });
}
